import React from 'react';

import Button from '@pb/kit-component-button';
import {Dialog} from '@pb/kit-component-dialog-v2';
import {useShown} from '@pb/kit-hooks-use-shown';

import {DeleteSsoSettingsModal} from './sso-settings-deletion-modal';

type Props = {
    disabled: boolean,
    accountId: number,
    onDeleted: () => void,
};

export const SsoSettingsDeletion = ({disabled, accountId, onDeleted}: Props) => {
    const {shown, onClick, onClose} = useShown();

    return (
        <>
            <Button variant="Type.SECONDARY" colorVariant="ERROR" onClick={onClick} disabled={disabled}>
                Delete Settings
            </Button>
            <Dialog shown={shown} setShown={onClose}>
                <DeleteSsoSettingsModal onClose={onClose} accountId={accountId} onDeleted={onDeleted}/>
            </Dialog>
        </>
    );
};
